// extracted by mini-css-extract-plugin
export default {"container":"user_container__rnyWL","name":"user_name__+1tL6","avatar":"user_avatar__g-lyA"};